/**
 * Created by Ning Jiang on 2021-06-03.
 */

import {TombstoneRipSymbol} from "./TombstoneRipSymbol";
import {TombstoneRipSymbolState} from "./TombstoneRipSymbolConfig";
import {SymbolStack} from "../../core/reel/stackedsymbol/StackedSymbol";
import {TombstoneRip} from "../TombstoneRip";
import {gsap, TimelineLite} from "gsap";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {ShootingController} from "../view/ShootingController";
import {MathHelper} from "../../core/utils/MathHelper";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";

export class TombstoneRipStackedWild extends TombstoneRipSymbol {

    private _topShotRange = new PIXI.Rectangle(-134 * 0.4, -236, 134 * 0.8, 40);
    private _bottomShotRange = new PIXI.Rectangle(-134 * 0.4, 196, 134 * 0.4, 40);
    protected _ripAssetName:string = "initialWin/xRip_W";

    private _bottomEffects:PIXI.Container;
    private _multiplierContainer:PIXI.Container;
    private _multiplierText:PIXI.Sprite;
    private _multiplierGlow:PIXI.Sprite;
    private _holeContainer:PIXI.Container;
    private _guySpine:PIXI.spine.Spine;
    private _ropeSpine:PIXI.spine.Spine;
    private _topEffects:PIXI.Container;

    private _stack:SymbolStack | null;
    public get stack():SymbolStack | null {
        return this._stack;
    }

    public set stack(value:SymbolStack | null) {
        if(this._stack || value == null) {
            debugger;
            throw new Error("TombstoneRipStackedWild.set stack():Cannot change stack!");
        }

        this._stack = value;
        this._stack!.addSymbol(this);
    }

    private _currentMultiplier:number = 0;
    public get currentMultiplier() {
        return this._currentMultiplier;
    }

    constructor(symbolName:string, reelId:number, initState:TombstoneRipSymbolState) {
        super(symbolName, reelId, initState);
    }

    protected getCenterPosition():PIXI.Point {
        return new PIXI.Point(0,
            (this.stackedSymbolName.totalNum * this.symbolStep - this.bottomPadding) * 0.5 - (this.stackedSymbolName.index * this.symbolStep + this.symbolHeight * 0.5)
        );
    }

    protected initAnimation() {
        this._bottomEffects = new PIXI.Container();
        this.addChild(this._bottomEffects);

        super.initAnimation();

        this._bottomEffects.position.set(this._centerPosition.x, this._centerPosition.y);

        this._multiplierContainer = new PIXI.Container();
        this._multiplierContainer.position.set(this._centerPosition.x, this._centerPosition.y + 220);

        this._multiplierGlow = new PIXI.Sprite();
        this._multiplierGlow.anchor.set(0.5);
        this._multiplierGlow.alpha = 0;
        this._multiplierContainer.addChild(this._multiplierGlow);

        this._multiplierText = new PIXI.Sprite();
        this._multiplierText.anchor.set(0.5);
        this._multiplierContainer.addChild(this._multiplierText);

        this._holeContainer = new PIXI.Container();
        this._holeContainer.position.set(this._centerPosition.x, this._centerPosition.y);

        this._topEffects = new PIXI.Container();
        this._topEffects.position.set(this._centerPosition.x, this._centerPosition.y);
    }

    protected updateLayers() {
        if(this._ropeSpine) {
            this.addChild(this._ropeSpine);
        }
        if(this._guySpine) {
            this.addChild(this._guySpine);
        }
        this._parts.forEach(part => this.addChild(part));
        this.addChild(this._multiplierContainer);
        super.updateLayers();
        this.addChild(this._holeContainer);
        if(this._splitBloodContainer) {
            this.addChild(this._splitBloodContainer);
        }
        if(this._rip) {
            this.addChild(this._rip);
        }
        if(this._topEffects) {
            this.addChild(this._topEffects);
        }
    }

    protected getStateTexture(state?:TombstoneRipSymbolState):PIXI.Texture[] {
        let texturePath = `${this.stackedSymbolName.symName}/${this.stackedSymbolName.symName}`;
        if(state === TombstoneRipSymbolState.SPIN || state === TombstoneRipSymbolState.LANDING) {
            texturePath += `_${state}`;
        }

        return TombstoneRip.assetLoader.getTextures(texturePath);
    }

    public onRemove() {
        if(this._stack) {
            this._stack.removeSymbol(this);
            this._stack = null;
        }
        super.onRemove();
    }

    protected addSplitSymbolAnimation(tl:TimelineLite, oldSymbolSize:number, type:number):void {
        // Logger.logDev(`wild split, currentMultiplier = ${this.currentMultiplier}`);
        const addedMultiplier = this.currentMultiplier;
        this.prepareGuySpine();
        tl.add([
            this.updateMultiplier(this.currentMultiplier * 2, true),
            () => {
                this.shotSymbol(this.getRandomPointInRange(this._bottomShotRange));
                TombstoneRip.multiplier.addMultiplier(addedMultiplier, `stackedWildSplitting on reel${this.reelId}`);
                this.updateLayers();
                this._guySpine.visible = true;
                this._guySpine.state.setAnimation(0, "shot", false);
                // this._ropeSpine.visible = true;
                // this._ropeSpine.state.setAnimation(0, `${this.stackedSymbolName.symName}down`, false);
                if(TombstoneRip.model.parsedGameData.singleWin > 0) {
                    const battleTl = new TimelineLite();
                    for(let i = 0; i < 2; i++) {
                        const battle = new TimelineSprite(TombstoneRip.assetLoader.getTextures("scatter/loop/battle_"));
                        battle.blendMode = PIXI.BLEND_MODES.ADD;
                        battle.anchor.set(0.5);
                        battle.scale.set(1.32, 3.28);
                        battle.alpha = 0;
                        this._bottomEffects.addChild(battle);
                        battleTl.add(battle.getAnimationAutoShowHide(), 0);
                        battleTl.add(gsap.to(battle, {alpha : 1, duration : 0.1}), 0);
                        battleTl.add(gsap.to(battle, {alpha : 0, duration : 0.133}), 0.1);

                        const glow = new PIXI.Sprite(TombstoneRip.assetLoader.getTextures("popGlow")[0]);
                        glow.blendMode = PIXI.BLEND_MODES.ADD;
                        glow.anchor.set(0.5);
                        glow.scale.set(1.36, 1.05);
                        glow.rotation = i === 0 ? 0 : Math.PI;
                        glow.alpha = 0.45;
                        glow.position.set(0, i === 0 ? -116 : 142);
                        this._topEffects.addChild(glow);
                        battleTl.add(gsap.to(glow, {alpha : 1, duration : 0.066}), 0);
                        battleTl.add(gsap.to(glow, {alpha : 0, duration : 0.267}), 0.066);

                        battleTl.add(() => {
                            battle.parent.removeChild(battle);
                            battle.destroy();
                            glow.parent.removeChild(glow);
                            glow.destroy();
                        });
                    }
                    battleTl.play();
                }
            }
        ], this._splitSplashDelay);
        tl.add(this.getPartDaggerSplitAnimation(this._multiplierContainer), this._splitSplashDelay);
    }

    protected getSplitBasePosition():PIXI.Point {
        const p = super.getStagePosition();
        // + 200 to move it from center down to the multiplier
        return new PIXI.Point(0, this.symbolHeight - this.stackedSymbolName.index * this.symbolHeight + 222);
    }

    public updateMultiplier(value:number, animate:boolean):TimelineLite {
        Logger.logDev(`wild update to multiplier ${value}`);
        const tl = new TimelineLite();
        if(value === this.currentMultiplier) {
            return tl;
        }

        (<TombstoneRipStackedWild[]>this.stack?.symbols).forEach((w:TombstoneRipStackedWild) => {
            w._currentMultiplier = value;
        })

        tl.add(() => {
            (<TombstoneRipStackedWild[]>this.stack?.symbols).forEach((w:TombstoneRipStackedWild) => {
                w._multiplierText.texture = TombstoneRip.assetLoader.getTextures(`W/x${value}`)[0];
            })
        }, 0);

        if(animate) {
            this._multiplierGlow.texture = TombstoneRip.assetLoader.getTextures(`wild/multiplier/x${value}`)[0];
            tl.add([
                gsap.to(this._multiplierText.scale, {x : 1.5, y : 1.3, duration : 0.1}),
                gsap.to(this._multiplierGlow, {alpha : 1, duration : 0.1})
            ]);
            tl.add([
                gsap.to(this._multiplierText.scale, {x : 1, y : 1, duration : 0.5}),
                gsap.to(this._multiplierGlow, {alpha : 0, duration : 0.5})
            ]);
        }

        return tl;
    }

    public playLanding(init:boolean = false):TimelineLite {
        const tl = new TimelineLite();
        if(init && !this.visible) {
            return tl;
        }
        this.prepareGuySpine();
        tl.add(() => {
            this.getStateAnimation(TombstoneRipSymbolState.NORMAL,
                {duration : 0.01, alpha : 1},
                {duration : 0.01, alpha : 0});
            this._guySpine.visible = true;
            this._guySpine.state.setAnimation(0, "landing", false);
            this._ropeSpine.visible = true;
            this._ropeSpine.state.setAnimation(0, `${this.stackedSymbolName.symName}landing`, false);
            if(!init) {
                this.shotSymbol(this.getLandingShotPosition());
            }
        });
        if(!init) {
            tl.add([
                this.updateMultiplier(1, true),
                () => TombstoneRip.multiplier.addMultiplier(1, `stackedWildLanding on reel${this.reelId}`)
            ]);
            tl.add(gsap.to(this, {duration : 0.01}), 0);
        }

        return tl;
    }

    private getLandingShotPosition():PIXI.Point {
        if(TombstoneRip.model.parsedGameData.nudgeSteps[this.reelId] > 0) {
            return this.getRandomPointInRange(this._bottomShotRange);
        }
        if(TombstoneRip.model.parsedGameData.nudgeSteps[this.reelId] < 0) {
            return this.getRandomPointInRange(this._topShotRange);
        }

        return this.getRandomPointInRange(Math.random() > 0.5 ? this._bottomShotRange : this._topShotRange);
    }

    private getRandomPointInRange(range:PIXI.Rectangle):PIXI.Point {
        return new PIXI.Point(
            MathHelper.randomNumberInRange(range.x, range.x + range.width),
            MathHelper.randomNumberInRange(range.y, range.y + range.height)
        );
    }

    private shotSymbol(position:PIXI.Point):void {
        const gunType = this.getGunType();
        ShootingController.shotAt(gunType, TombstoneRip.model.parsedGameData.singleWin > 0, this._holeContainer, position, true);
    }

    private getGunType():string {
        if((Math.abs(TombstoneRip.model.parsedGameData.nudgeSteps[this.reelId]) + TombstoneRip.multiplier.currentMultiplier) > 2) {
            return ShootingController.GUN_SHOTGUN;
        }

        let sum = 0;
        for(let i = 1; i <= this.reelId; i++) {
            if(TombstoneRip.model.parsedGameData.doReelNudge[i]) {
                sum += 1;
            }
            sum += Math.abs(TombstoneRip.model.parsedGameData.nudgeSteps[i]);
        }
        if(sum > 2) {
            return ShootingController.GUN_SHOTGUN;
        }

        return ShootingController.GUN_PISTOL;
    }

    public playNudgeUp():TimelineLite {
        this.prepareGuySpine();
        const tl = new TimelineLite();
        tl.add([
            () => {
                this.updateLayers();
                this._guySpine.visible = true;
                this._guySpine.state.setAnimation(0, "up", false);
                this._ropeSpine.visible = true;
                this._ropeSpine.state.setAnimation(0, `${this.stackedSymbolName.symName}up`, false);
            },
            () => this.shotSymbol(this.getRandomPointInRange(this._topShotRange))
        ]);
        tl.add(gsap.to(this, {duration : this._guySpine.spineData.findAnimation("up").duration}));
        return tl;
    }

    public playNudgeDown():TimelineLite {
        this.prepareGuySpine();
        const tl = new TimelineLite();
        tl.add([
            () => {
                this.updateLayers();
                this._guySpine.visible = true;
                this._guySpine.state.setAnimation(0, "down", false);
                this._ropeSpine.visible = true;
                this._ropeSpine.state.setAnimation(0, `${this.stackedSymbolName.symName}down`, false);
            },
            () => this.shotSymbol(this.getRandomPointInRange(this._bottomShotRange))
        ]);
        tl.add(gsap.to(this, {duration : this._guySpine.spineData.findAnimation("down").duration}));
        return tl;
    }

    private prepareGuySpine():void {
        if(!this._guySpine) {
            this._guySpine = new PIXI.spine.Spine(TombstoneRip.assetLoader.getSpineAsset(this.stackedSymbolName.symName));
            this._guySpine.autoUpdate = true;
            this._guySpine.position.set(this._centerPosition.x, this._centerPosition.y);

            this._ropeSpine = new PIXI.spine.Spine(TombstoneRip.assetLoader.getSpineAsset(`WRope`));
            this._ropeSpine.autoUpdate = true;
            this._ropeSpine.position.set(this._centerPosition.x, this._centerPosition.y);

            const guyMask = new PIXI.Graphics();
            guyMask.beginFill(0x00FF00, 1);
            guyMask.drawShape(new PIXI.Rectangle(-this.symbolWidth * 0.5, -this.symbolHeight * 1.5, this.symbolWidth, this.symbolHeight * 3));
            guyMask.endFill();
            guyMask.position.set(this._centerPosition.x, this._centerPosition.y);
            this.addChild(guyMask);
            this._guySpine.mask = guyMask;
            this._ropeSpine.mask = guyMask;
        }
    }

    public playLandingState(duration:number):void {
        this.getStateAnimation(TombstoneRipSymbolState.LANDING,
            {duration : duration, alpha : 1},
            {duration : duration, alpha : 0});
    }
}